import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState, useRef, useEffect } from 'react';
import { hotelViewStyles } from './styles';

interface HotelDescriptionProps {
  description?: string;
}

const MAX_DESCRIPTION_HEIGHT = 200;

export const HotelDescription = ({ description }: HotelDescriptionProps) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      const contentHeight = contentRef.current.scrollHeight;
      setShowReadMore(contentHeight > MAX_DESCRIPTION_HEIGHT);
    }
  }, [description]);

  if (!description) return null;

  const handleToggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Box sx={hotelViewStyles.hotelInfo}>
      <Typography sx={{ mb: 2 }} variant="h6">
        {t('hotelContent.nimbuxHotels.card.information')}
      </Typography>
      <Box
        sx={{
          position: 'relative',
          maxHeight: isExpanded ? 'none' : MAX_DESCRIPTION_HEIGHT,
          overflow: 'hidden',
        }}
      >
        <Typography
          ref={contentRef}
          variant="body2"
          color="text.secondary"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        {!isExpanded && showReadMore && (
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: 80,
              background: 'linear-gradient(transparent, rgba(255, 255, 255, 0.9) 70%, white 100%)',
              pointerEvents: 'none',
            }}
          />
        )}
      </Box>
      {showReadMore && (
        <Button variant="text" onClick={handleToggleExpanded} size="small" sx={{ textTransform: 'none', width: 'fit-content' }}>
          {isExpanded ? t('common.showLess') : t('common.readMore')}
        </Button>
      )}
    </Box>
  );
};
